module.exports = __webpack_public_path__ + "img/luxuryyacht_option_02.613c134b.jpg";